var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 74.16171,
    y1: 9.861931,
    x2: 46.560318,
    y2: 53.413616,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#03B591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#029C7D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L128 0L128 128L0 128L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinGreen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupa-masek"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L128 0L128 128L0 128L0 0Z",
    id: "artboard_1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "128-x-128",
    transform: "translate(0 -6.519258E-09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.51926e-09L128 6.51926e-09L128 128L0 128L0 6.51926e-09Z",
    id: "artboard_1",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(17 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6116 0.00835088C70.086 -0.405298 93.8976 14.5413 93.8976 46.3838C93.8976 78.2262 46.6116 127.378 46.6116 127.378C46.6116 127.378 0 79.8808 0 48.0384C0 16.1959 23.1371 0.422 46.6116 0.00835088L46.6116 0.00835088Z",
    id: "pin#1",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9276 39C32.9276 31.268 39.1956 25 46.9276 25C54.6596 25 60.9276 31.268 60.9276 39C60.9276 46.732 54.6596 53 46.9276 53C39.1956 53 32.9276 46.732 32.9276 39L32.9276 39Z",
    id: "pin-center",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pinGreen.e92a1b21aa1185b9aebabef8f59cb77f.svg";